
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.105 1.3C4.341.847 4.625.456 5 0c.376.456.66.847.895 1.3.696 1.342.721 2.915.721 4.427v8.38c-.024.753-.253.866-.788.893H4.172c-.535-.027-.764-.14-.788-.893v-8.38c0-1.512.025-3.085.721-4.427z"}})])
          )
        }
      }
    